module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/My-Dinner-With-Herve.6e9ecf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/My-Dinner-With-Herve.jpg
// module id = x2Tq
// module chunks = 0